module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp1_8003.5f38a5cd.png";